import { useState, MouseEvent } from "react";
import { InputEscapeResult, ResponseEscapeResult } from "../Types/api";
import useEscapeRoomApi from "./useEscapeRoomApi";
import { isResponseEscapeResult } from "../Helpers/helpers";

const useLeaderboard = () => {
  const [leaderboardRooms, setLeaderboardRooms] = useState<string[]>([]);
  const [selectedRoom, setSelectedRoom] = useState<string>("");
  const [selectedRoomLeaderboardData, setSelectedRoomLeaderboardData] =
    useState<Map<string, InputEscapeResult[]>>(new Map());
  const [actionMenuOpen, setActionMenuOpen] = useState<string | null>(null);
  const { deleteLeaderboardScore, retrieveLeaderboardResultsByEvent, retrieveLeaderboardResults } = useEscapeRoomApi();


  const handleActionMenuToggle = (index: string, event: MouseEvent) => {
    event.stopPropagation();
    setActionMenuOpen((prev) => (prev === index ? null : index));
  };

  //Not been updated by kim yet
  const handleDelete = async (name: string, event: string, room: string) => {
    try {
      const response = await deleteLeaderboardScore(event, name, room);

      if (response) {
        setSelectedRoomLeaderboardData((prev) => {
          const updated = new Map(prev);
          const currentRoomResults = updated.get(selectedRoom) || [];

          updated.set(
            selectedRoom,
            currentRoomResults.filter((result) => result.name !== name)
          );

          return updated;
        });
        setActionMenuOpen(null);
      } else {
        console.error("Failed to delete result");
      }
    } catch (error) {
      console.error("Error deleting result:", error);
    }
  };

  const getLeaderboardResults = async (): Promise<ResponseEscapeResult[]> => {

    const eventName = localStorage.getItem("Event");  
    const response: ResponseEscapeResult[] = (eventName) ? await retrieveLeaderboardResultsByEvent(eventName) : await retrieveLeaderboardResults();

    if (!isResponseEscapeResult(response)) {
      console.error("Invalid data format:", response);
      throw new Error("Invalid data format from leaderboard lookup");
    } else {
      return response;
    }

  }

  return {
    leaderboardRooms,
    setLeaderboardRooms,
    selectedRoom,
    setSelectedRoom,
    selectedRoomLeaderboardData,
    setSelectedRoomLeaderboardData,
    actionMenuOpen,
    handleActionMenuToggle,
    handleDelete,
    getLeaderboardResults
  };
};

export default useLeaderboard;
